import { useCallback, useContext } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { studentEvaluationDemoContext } from '~/pages/authenticated/personalTrainer/studentEvaluationDemo'

export const WetmanCol: React.FC = () => {
  const { data } = useContext(studentEvaluationDemoContext)

  const updateData = useCallback(() => {
    //
  }, [])

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(8)
  }, [])

  return (
    <div>
      {data ? (
        <MaskedInput
          mask='float'
          inputMode='numeric'
          mode='horizontal'
          label='Abdômen (cm)'
          placeholder='0,00'
          value={data.abdomen}
          onFocus={handleFocus}
          onChange={updateData}
        />
      ) : null}
    </div>
  )
}
